export class DateSummary {
  date: string;
}
